/* eslint-disable quotes */
import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable()
export class CustomSentryErrorHandler
  extends Sentry.SentryErrorHandler
{
  constructor() {
    super({ showDialog: false });
  }

  override handleError(error: any): void {
    // error case deploy โค้ดใหม่ แล้วมี cache เก่าอยู่ใน browser จะทำการ reload ใหม่
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (chunkFailedMessage.test(error?.message)) {
      window.location.reload();
      return;
    }

    super.handleError(error);
  }
}

export const IGNORE_ERRORS = [
  /**
   * pdfjs,pdf-viewer error
   */
  "Cannot read properties of undefined (reading 'getPage')",
  "undefined is not an object (evaluating 'this._pdf.getPage')",
  "Cannot destructure property 'div' of 't' as it is undefined",
  "Cannot destructure property 'div' of 'pageView' as it is undefined",
  'Right side of assignment cannot be destructured',
  "Failed to execute 'getComputedStyle' on 'Window': parameter 1 is not of type 'Element'",
  'NG0100: ExpressionChangedAfterItHasBeenCheckedError:',
  "Failed to execute 'containsNode' on 'Selection': parameter 1 is not of type 'Node'",
  "Uncaught TypeError: Cannot read properties of undefined (reading 'defaults')",
  'Invalid page request.',
  't is undefined',
  'Window.getComputedStyle',
  'Error: Transport destroyed',
  'this._pdf is undefined',
  'can\'t access property "_on", i is undefined',
  'Object captured as exception with keys',
  'The `container` must be absolutely positioned',
  'AbortError: signal is aborted without reason',
  'Worker was terminated',

  /**
   * about loading website not sure why error
   */
  'ChunkLoadErrors',
  'ChunkLoadError',
  'Loading chunk',

  /**
   * rxjs error
   */
  'Promise.withResolvers',
  "You provided 'undefined' where a stream was expected",

  /**
   * already handle in error.interceptor.ts
   */
  '/api/token-refresh/: 401 OK',
  '/api/token-refresh/: 0 Unknown Error',
  '/api/token-refresh/: 401 Unauthorized',

  /**
   * about survicate
   */
  '*.survicate.com',

  /**
   *  loading error
   */
  './assets/i18n/en.json: 0 Unknown Error',
  './assets/i18n/th.json: 0 Unknown Error',
  'Http failure response',
  'Http failure during parsing',
  'Load Failed errors',
  'Load failed',
  'Failed to fetch',
];
